module.exports = __webpack_public_path__ + "static/media/teoLogo2.c2e7fc7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teoLogo2.png
// module id = 1868
// module chunks = 0